// extracted by mini-css-extract-plugin
export default {"aboutUspage":"AboutUs_aboutUspage__Mh1Us"};